import { useMediaQuery } from '@mantine/hooks'

export const useTouchDevice = () =>
	useMediaQuery('(hover: none) and (pointer: coarse)')

export const useTabletLayout = () => useMediaQuery('(max-width: 1024px)')
